/**
 * App Info API service
 */

import apiClient from './api';
import { AppInfo } from '../types';

export const appInfoApi = {
  /**
   * Get application info and configuration
   */
  async getAppInfo(): Promise<AppInfo> {
    const response = await apiClient.get<AppInfo>('/app-info');
    return response.data;
  },
};